import { render, staticRenderFns } from "./PainelHome.vue?vue&type=template&id=2bafd6ad&scoped=true"
import script from "./PainelHome.vue?vue&type=script&lang=js"
export * from "./PainelHome.vue?vue&type=script&lang=js"
import style0 from "./PainelHome.css?vue&type=style&index=0&id=2bafd6ad&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafd6ad",
  null
  
)

export default component.exports